// counterReducer.js
const initialState = {
    count: 0
  };
  
  const counterReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'INCREMENT':
        return { count: state.count + action.payload }; // Use payload to increment
      case 'DECREMENT':
        return { count: state.count - action.payload }; // Use payload to decrement
      default:
        return state;
    }
  };
  
  
  export default counterReducer;
  